<div class="center">
    <img class="error-icon" src="./images/error.svg" />
    <p class="error-title">{{ 'serverError.title' | translate }}</p>
    <p class="error-message">{{ 'serverError.message' | translate }}</p>
</div>
